import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'ngx-loading';
import { AuthenticateService } from '../../shared/services/authenticate.service'
import { CropsService } from 'src/app/shared/services/crops.service';
import { CognitoService } from 'src/app/shared/services/cognito.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { TokenStorageService } from 'src/app/shared/services/token.service';
const now = new Date();

@Component({
  selector: 'app-maintool',
  templateUrl: './maintool.component.html',
  styleUrls: ['./maintool.component.sass']
})
export class MaintoolComponent implements OnInit {

  @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  showStepper: boolean = false;
  loading: boolean;
  showsearchdata: boolean = true;
  varietyArray: any = [];
  loadingcrops: boolean;
  collectionSize: any;
  groupName = this.tokenService.getGroup();
  globalImgUrl: string;
  previousPage: number;
  skip: number;
  page = 1;
  searchStr: string = '';
  cropDetailsArray: any = [];
  selectedCropName: string = '';

  constructor(private authService: AuthenticateService,
    private tokenService : TokenStorageService,
    private cropsService:CropsService,
    private profileService: ProfileService,
    private cognitoService: CognitoService) { }

  ngOnInit() {
    this.cognitoService.getCurrentUserToken().then((res:any) => {
      this.groupName = res.attributes.family_name;
      this.getAllVarieties();
    })
    setTimeout(() => {
      this.globalImgUrl = this.authService.s3url();
    }, 500);
    this.profileService.gotoMain.subscribe((data) => {
      console.log("ProfileData", data);
      this.showStepper = false;
      this.getAllVarieties();
    })
  }

  getAllVarieties() {
    this.showsearchdata = true;
    this.loadingcrops = true;
    var count = { group: this.groupName};
    console.log("countoptions == ", count);
    this.cropsService.getVarietyCount(count).then((data: any) => {
      console.log("COUNT : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size
        var options = {
          group: this.groupName,
          options: {
            limit: 20,
            sortFields: { createTs: -1 },
            skip: 0
          }
        }
        console.log("options == ", options);
        this.varietyArray = [];
        this.cropsService.getAllCropsVariety(options).then((data: any) => {
          console.log("cropData == ", data);
          if (data.length > 0) {
            this.varietyArray = data;
            console.log("varietyarray", this.varietyArray)
            this.loadingcrops = false;
          } else {
            this.loadingcrops = false;
          }

        })
      } else {
        this.loadingcrops = false;
      }
    });
  }

  loadPage(pageNumber: number) {
    this.loading = true;
    console.log("page number ", pageNumber, this.previousPage)
    if (pageNumber !== this.previousPage) {
      this.skip = (pageNumber * 20) - 20;
      this.previousPage = pageNumber;
      this.loadData(this.skip);
    }
  }

  loadData(skip) {
    var count = { group: this.groupName}
    this.cropsService.getVarietyCount(count).then((data: any) => {
      console.log("Demand size : ", data)
      if (data.length > 0) {
        this.collectionSize = data[0].size
        console.log("collectionsize", this.collectionSize)
        var options = {
          group: this.groupName,
          options: {
            limit: 20,
            sortFields: { createTs: -1 },
            skip: skip
          }
        }
        this.varietyArray = [];
        this.cropsService.getAllCropsVariety(options).then((data: any) => {
          console.log("getDemandCount : ", data);
          if (data.length > 0) {
            this.varietyArray = data;
            this.loading = false;
          } else {
            this.loading = false;
          }
        });
      } else {
        this.loading = false;
      }
    });
  }

  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }

  openStepper(variety) {
    this.selectedCropName = variety.cropName;
    console.log(variety);
    this.cropDetailsArray = [];
    this.cropDetailsArray = variety;
    this.showStepper = !this.showStepper;
  }

  backToVarieties() {
    this.showStepper = !this.showStepper;
  }

  searchByName() {
    if (this.searchStr != '') {
      var obj = {
        group: this.groupName,
        field: 'varietyName',
        text: this.searchStr,
        tableName: 'cropvarieties',
      };
      console.log("search obj : ", obj)
      this.cropsService.getcropvarietiesRegex(obj).then((data: any) => {
        console.log("searched", data)
        this.searchStr = '';
        this.varietyArray = [];
        if (data.length > 0) {
          this.varietyArray = data;
          this.showsearchdata = false;
          console.log("varietyArray", this.varietyArray);
        }
        else {
          this.showsearchdata = false;
        }
      })
    }
  }

}
